import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["defaultSection", "smtpSection", "graphSection", "defaultTestSection", "smtpTestSection", "graphTestSection"]

  connect() {
    this.toggleSections()
  }

  toggleSections() {
    const selectedType = this.getSelectedConfigurationType()

    // Hide all sections first and disable their required fields
    if (this.hasDefaultSectionTarget) {
      this.defaultSectionTarget.classList.add("hidden")
    }
    if (this.hasSmtpSectionTarget) {
      this.smtpSectionTarget.classList.add("hidden")
      this.setRequiredFields(this.smtpSectionTarget, false)
    }
    if (this.hasGraphSectionTarget) {
      this.graphSectionTarget.classList.add("hidden")
      this.setRequiredFields(this.graphSectionTarget, false)
    }
    if (this.hasDefaultTestSectionTarget) this.defaultTestSectionTarget.classList.add("hidden")
    if (this.hasSmtpTestSectionTarget) this.smtpTestSectionTarget.classList.add("hidden")
    if (this.hasGraphTestSectionTarget) this.graphTestSectionTarget.classList.add("hidden")

    // Show the appropriate sections and enable their required fields
    switch(selectedType) {
      case "custom_smtp":
        if (this.hasSmtpSectionTarget) {
          this.smtpSectionTarget.classList.remove("hidden")
          this.setRequiredFields(this.smtpSectionTarget, true)
        }
        if (this.hasSmtpTestSectionTarget) this.smtpTestSectionTarget.classList.remove("hidden")
        break
      case "microsoft_graph":
        if (this.hasGraphSectionTarget) {
          this.graphSectionTarget.classList.remove("hidden")
          this.setRequiredFields(this.graphSectionTarget, true)
        }
        if (this.hasGraphTestSectionTarget) this.graphTestSectionTarget.classList.remove("hidden")
        break
      case "default":
      default:
        // Default configuration - show ENV values and test section
        if (this.hasDefaultSectionTarget) this.defaultSectionTarget.classList.remove("hidden")
        if (this.hasDefaultTestSectionTarget) this.defaultTestSectionTarget.classList.remove("hidden")
        break
    }
  }

  setRequiredFields(section, isRequired) {
    const requiredFields = section.querySelectorAll('input[required], select[required], textarea[required]')
    requiredFields.forEach(field => {
      if (isRequired) {
        field.setAttribute('required', 'required')
      } else {
        field.removeAttribute('required')
      }
    })
  }

  getSelectedConfigurationType() {
    const radioButtons = this.element.querySelectorAll('input[name="account[email_configuration_type]"]')
    for (const radio of radioButtons) {
      if (radio.checked) {
        return radio.value
      }
    }
    return "default"
  }
}
